import { Link } from "react-router-dom";

interface ProductItem {
  icon: string;
  name: string;
  description: string;
  link: string;
}

const products: ProductItem[] = [
  {
    icon: "ri-stack-fill",
    name: "StackMap BOS",
    description: "Business Operating System for HR, operations, sales, marketing, workplace services, finance, audit, and performance management.",
    link: "/products",
  },
  {
    icon: "ri-shopping-cart-2-line",
    name: "OMS",
    description: "Order, fulfilment, inventory, and warehouse management for logistics and distribution businesses.",
    link: "/products/oms",
  },
  {
    icon: "ri-heart-pulse-line",
    name: "Get Fit",
    description: "Fitness management platform for gyms, trainers, wellness businesses, and fitness communities.",
    link: "/products/get-fit",
  },
  {
    icon: "ri-tools-line",
    name: "Custom Solutions",
    description: "Bespoke software development for businesses with unique requirements that go beyond our standard product suite.",
    link: "/bespoke",
  },
];

export default function ProductCoverage() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-900">
      <div className="section-padding">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Product{" "}
              <span className="text-emerald-accent">Ecosystem</span>
            </h2>
            <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              All StackMap products are available across our pricing plans. Select what you need today and expand tomorrow.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {products.map((product) => (
              <div
                key={product.name}
                className="glass-card p-6 md:p-7 flex flex-col items-center text-center group"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-emerald-accent/10 border border-emerald-accent/20 mb-5">
                  <i className={`${product.icon} text-emerald-accent text-2xl`} />
                </div>
                <h4 className="text-base font-semibold text-white mb-2">{product.name}</h4>
                <p className="text-xs text-silver-400 leading-relaxed mb-5 flex-1">{product.description}</p>
                <Link
                  to={product.link}
                  className="inline-flex items-center gap-1.5 text-xs font-medium text-emerald-accent hover:text-emerald-soft transition-colors cursor-pointer"
                >
                  Learn More
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}